import { render, staticRenderFns } from "./SelectingValuesDefault.vue?vue&type=template&id=4a08faa1&"
import script from "./SelectingValuesDefault.vue?vue&type=script&lang=js&"
export * from "./SelectingValuesDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports